'use strict';

var Css = require("bs-css-emotion/lib/js/src/Css.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Logrocket = require("logrocket");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Client = require("react-dom/client");
var App$PvpcontrollerWeb = require("./App.js");
var Debugging$PvpcontrollerWeb = require("./Debugging.js");

Curry._2(Css.$$global, "::-webkit-scrollbar", {
      hd: Css.background(Css.hex("3c4046")),
      tl: {
        hd: Css.width(Css.px(13)),
        tl: {
          hd: Css.borderRadius(Css.px(10)),
          tl: /* [] */0
        }
      }
    });

Curry._2(Css.$$global, "::-webkit-scrollbar-thumb", {
      hd: Css.border(Css.px(3), Css.solid, Css.hex("3c4046")),
      tl: {
        hd: Css.background(Css.hex("62676d")),
        tl: {
          hd: Css.borderRadius(Css.px(10)),
          tl: /* [] */0
        }
      }
    });

Curry._2(Css.$$global, "body", {
      hd: Css.overflowX(Css.hidden),
      tl: {
        hd: Css.maxWidth({
              NAME: "percent",
              VAL: 100
            }),
        tl: {
          hd: Css.height({
                NAME: "percent",
                VAL: 100
              }),
          tl: /* [] */0
        }
      }
    });

Curry._2(Css.$$global, "*", {
      hd: Css.margin("zero"),
      tl: {
        hd: Css.padding("zero"),
        tl: /* [] */0
      }
    });

Curry._2(Css.$$global, "a", {
      hd: Css.textDecoration(Css.none),
      tl: /* [] */0
    });

Curry._2(Css.$$global, "#root", {
      hd: Css.overflowX(Css.hidden),
      tl: {
        hd: Css.height({
              NAME: "percent",
              VAL: 100
            }),
        tl: /* [] */0
      }
    });

Curry._2(Css.$$global, "html", {
      hd: Css.height({
            NAME: "percent",
            VAL: 100
          }),
      tl: /* [] */0
    });

Curry._2(Css.$$global, "input", {
      hd: Css.backgroundColor(Css.transparent),
      tl: {
        hd: Css.border("zero", Css.none, Css.white),
        tl: {
          hd: Css.fontSize(Css.px(18)),
          tl: {
            hd: Css.width(Css.px(150)),
            tl: {
              hd: Css.borderBottom(Css.px(2), Css.solid, Css.hex("3c4046")),
              tl: {
                hd: Css.focus({
                      hd: Css.borderBottom(Css.px(2), Css.solid, Css.hex("9d9d9e")),
                      tl: {
                        hd: Css.outlineWidth("zero"),
                        tl: /* [] */0
                      }
                    }),
                tl: /* [] */0
              }
            }
          }
        }
      }
    });

var loginApiVerifyUrl = "loginapi.dark-gaming.com/api/verify";

Logrocket.init("drcjix/pvp-manager", {
      network: {
        requestSanitizer: (function (request) {
            if (request.url.indexOf(loginApiVerifyUrl) > -1) {
              request.url = Caml_array.get(request.url.split(loginApiVerifyUrl), 0) + loginApiVerifyUrl + "/sanitized";
            }
            try {
              var url = new URL(request.url);
              var params = url.searchParams;
              if (Belt_Option.isSome(Caml_option.nullable_to_opt(params.get("token")))) {
                params.set("token", "sanitized");
              }
              if (Belt_Option.isSome(Caml_option.nullable_to_opt(params.get("sessionId")))) {
                params.set("sessionId", "sanitized");
              }
              request.url = (url.toString());
            }
            catch (_err){
              var match = request.url;
              switch (match) {
                case "first-contentful-paint" :
                case "first-paint" :
                    break;
                default:
                  Debugging$PvpcontrollerWeb.info("Failed URL parsing of " + request.url);
              }
            }
            return request;
          })
      },
      release: "v1.0",
      console: undefined
    });

var root = document.querySelector("#root");

if (root == null) {
  Debugging$PvpcontrollerWeb.error(Debugging$PvpcontrollerWeb.createError("Could not find root element"));
} else {
  Client.createRoot(root).render(React.createElement(App$PvpcontrollerWeb.make, App$PvpcontrollerWeb.makeProps(undefined, undefined)));
}

/*  Not a pure module */
